/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export class LogicalException extends Error {
  constructor(message?: string) {
    super(message || 'Logical exception');
  }
}

export class CancelError extends Error {
  isCancel: boolean;

  constructor() {
    super('Request cancelled');
    this.isCancel = true;
  }
}
